
// Getting project
export const GET_PROJECT_START = "MAP:GET_PROJECT_START";
export const GET_PROJECT_SUCCESS = "MAP:GET_PROJECT_SUCCESS";
export const GET_PROJECT_FAILURE = "MAP:GET_PROJECT_FAILURE";
export const CLEAR_PROJECT = "MAP:CLEAR_PROJECT";

// Getting projects
export const GET_PROJECTS_START = "MAP:GET_PROJECTS_START";
export const GET_PROJECTS_SUCCESS = "MAP:GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_FAILURE = "MAP:GET_PROJECTS_FAILURE";
export const CLEAR_PROJECTS = "MAP:CLEAR_PROJECTS";

// Getting sub projects
export const GET_SUB_PROJECT_START = "MAP:GET_SUB_PROJECT_START";
export const GET_SUB_PROJECT_SUCCESS = "MAP:GET_SUB_PROJECT_SUCCESS";
export const GET_SUB_PROJECT_FAILURE = "MAP:GET_SUB_PROJECT_FAILURE";

// Getting sub project elements
export const GET_SUB_PROJECT_ELEMENT_START = "MAP:GET_SUB_PROJECT_ELEMENT_START";
export const GET_SUB_PROJECT_ELEMENT_SUCCESS = "MAP:GET_SUB_PROJECT_ELEMENT_SUCCESS";
export const GET_SUB_PROJECT_ELEMENT_FAILURE = "MAP:GET_SUB_PROJECT_ELEMENT_FAILURE";
